import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { colorsAPI } from '../services/api';
import './Users.css';

const Colors = () => {
  const navigate = useNavigate();
  const [colors, setColors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadColors();
  }, []);

  const loadColors = async () => {
    setLoading(true);
    try {
      const response = await colorsAPI.getAll();
      const colorsData =
        response.data?.colors || (Array.isArray(response.data) ? response.data : []);
      setColors(colorsData);
    } catch (error) {
      console.error('Error loading colors:', error);
      toast.error('Error loading colors: ' + (error.response?.data?.message || error.message));
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this color?')) return;
    try {
      await colorsAPI.delete(id);
      loadColors();
      toast.success('Color deleted!');
    } catch (error) {
      toast.error('Error deleting color: ' + (error.response?.data?.message || error.message));
    }
  };

  if (loading && colors.length === 0) {
    return <div className="loading">Loading colors...</div>;
  }

  return (
    <div className="users-container">
      <div style={{ marginBottom: '20px' }}>
        <Link to="/colors/new" className="btn btn-primary" style={{ display: 'inline-block' }}>
          + Add Color
        </Link>
      </div>

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Arabic</th>
              <th>Hex Code</th>
              <th>Preview</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {!loading && colors.length === 0 ? (
              <tr>
                <td colSpan="5" style={{ textAlign: 'center', padding: '20px' }}>
                  No colors found
                </td>
              </tr>
            ) : (
              colors.map((color) => (
                <tr key={color.id}>
                  <td>{color.name || 'N/A'}</td>
                  <td>{color.name_ar || '—'}</td>
                  <td>{color.hex_code || 'N/A'}</td>
                  <td>
                    {color.hex_code ? (
                      <div
                        style={{
                          width: '40px',
                          height: '40px',
                          backgroundColor: color.hex_code,
                          border: '1px solid #ddd',
                          borderRadius: '4px',
                        }}
                        title={color.hex_code}
                      />
                    ) : (
                      'N/A'
                    )}
                  </td>
                  <td className="actions">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => navigate(`/colors/${color.id}/edit`)}
                    >
                      Edit
                    </button>
                    <button type="button" className="btn btn-danger" onClick={() => handleDelete(color.id)}>
                      Delete
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Colors;
